import React, { useContext } from 'react';
import { ProfileContext } from '../../../context/Profile.context';
import AddressEntity from '../../Entities/AddressEntity';
import { Box, Checkbox, SectionTitle, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const SAME_AS_ADDRESS = 'Same as Principal Place of Business';
const BILLING_ADDRESS_FOOTNOTE = 'If your accounting department requires a purchase order please include it in the address section';

const CorporateAddresses = () => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const contactInfo = profileData && profileData.contactInfo;
    const principalAddressData = contactInfo && profileData.contactInfo.address;
    const billingAddressData = contactInfo && profileData.contactInfo.billingAddress;
    const execAddressData = contactInfo && profileData.contactInfo.executiveAddress;
    const isReadOnly = profileState.readOnly;

    const onCheckboxChanged = (value, field) => {
        const updateProfile = { ...contactInfo };
        let addressObj;
        updateProfile.address[field] = value;

        if (field === 'sameBillingAddress') addressObj = 'billingAddress';
        if (field === 'sameExecAddress') addressObj = 'executiveAddress';
        updateProfile[addressObj] = { ...updateProfile.address };

        delete updateProfile[addressObj][field];

        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'contactInfo',
            payload: updateProfile
        });
    };

    const onAddressChanged = (updatedObj, field) => {
        const updatedContactInfo = { ...contactInfo };
        updatedContactInfo[field] = updatedObj;

        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'contactInfo',
            payload: updatedContactInfo
        });
    };

    return <Box display='flex' flexDirection='column' gap={2}>
        <Box>
            <SectionTitle noUnderline>Corporate Addresses</SectionTitle>
        </Box>
        <Box display='flex' flexDirection='column' gap={1}>
            <Typography variant='subtitle1'>Principal Place of Business</Typography>
            <AddressEntity data={principalAddressData} title='Principal Place of Business' addressKey='address' isReadOnly={isReadOnly} onUpdate={onAddressChanged} />
        </Box>
        <Box display='flex' flexDirection='column' gap={1}>
            <Typography variant='subtitle1'>Billing Address</Typography>
            {!isReadOnly && <Checkbox
                label={SAME_AS_ADDRESS}
                checked={principalAddressData.sameBillingAddress}
                onChange={e => onCheckboxChanged(e.target.checked, 'sameBillingAddress')}
            />}
            <AddressEntity
                data={billingAddressData}
                title='Billing Address'
                isStatic={principalAddressData.sameBillingAddress}
                staticData={principalAddressData}
                addressKey='billingAddress'
                isReadOnly={isReadOnly}
                footNote={BILLING_ADDRESS_FOOTNOTE}
                onUpdate={onAddressChanged} />
        </Box>
        <Box display='flex' flexDirection='column' gap={1}>
            <Typography variant='subtitle1'>Principal Executive Office</Typography>
            {!isReadOnly && <Checkbox
                label={SAME_AS_ADDRESS}
                checked={principalAddressData.sameExecAddress}
                onChange={e => onCheckboxChanged(e.target.checked, 'sameExecAddress')}
            />}
            <AddressEntity data={execAddressData} title='Principal Executive Office' isStatic={principalAddressData.sameExecAddress} staticData={principalAddressData} addressKey='executiveAddress' isReadOnly={isReadOnly} onUpdate={onAddressChanged} />
        </Box>
    </Box>;
};

export default CorporateAddresses;
